import { GameObj } from "../GameObj";
import { UnitType } from "./UnitType";
import type { UnitContext, PlaceContext, ObjContext, MakeContext } from "./context";

export class Demon extends UnitType {
    readonly id = "demon";
    readonly displayName = "Demon";
    playerCanDeploy(ctx: UnitContext) { return ctx.world === ctx.game.netherworld; }
    canEnter(ctx: PlaceContext) { return this.inTile(ctx, ["land"]); }
    description() { return "Slow but can defeat everything."; }
    defeats(): (string | true)[] { return [true]; }
    // cost() { return { blood: 0, souls: 0, runes: 0 }; }
    cost() { return { blood: 250, souls: 5, runes: 12 }; }
    img(ctx: UnitContext) { return "demon_" + ctx.faction; }
    maxCooldown() { return 8000; }
    moveRange() { return 2.5; }
    make(ctx: MakeContext) { return new GameObj(ctx.faction, "demon"); }
    step(ctx: ObjContext) {
        if (ctx.faction !== "player") {
            this.hunt(ctx, c => {
                const obj = c.world.get(c.x, c.y);
                if (obj && this.canDefeat(obj.unitId)) return 2;
                if (c.game.influenceMap.get(c.x, c.y) !== ctx.faction) return 1;
                return 0;
            });
        }
    }
    influenceRange(): number { return 3; }
}
